import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import RestaurantMenuRoundedIcon from '@mui/icons-material/RestaurantMenuRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import ViewCarouselRoundedIcon from '@mui/icons-material/ViewCarouselRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
// import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: DashboardRoundedIcon,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/order/list',
      icon: ReceiptLongRoundedIcon
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: AssessmentRoundedIcon,
      children: [
        {
          id: 'revenue-report',
          title: 'Revenue Report',
          type: 'item',
          url: '/report/revenue',
          icon: PaymentsRoundedIcon
        },
        {
          id: 'order-report',
          title: 'Order Report',
          type: 'item',
          url: '/report/order',
          icon: ReceiptLongRoundedIcon
        },
        {
          id: 'tax-report',
          title: 'Tax Report',
          type: 'item',
          url: '/report/tax',
          icon: PaymentsRoundedIcon
        }
      ]
    },
    {
      id: 'driver-list',
      title: 'Drivers',
      type: 'item',
      url: '/driver/list',
      icon: LocalShippingRoundedIcon
    },
    {
      id: 'customer-list',
      title: 'Customers',
      type: 'item',
      url: '/customer/list',
      icon: PeopleAltRoundedIcon
    },
    {
      id: 'menu-management',
      title: 'Menu',
      type: 'collapse',
      icon: RestaurantMenuRoundedIcon,
      children: [
        {
          id: 'master-product-list',
          title: 'Products',
          type: 'item',
          url: '/master/product-list',
          icon: Inventory2RoundedIcon
        },
        {
          id: 'master-category-list',
          title: 'Categories',
          type: 'item',
          url: '/master/category-list',
          icon: CategoryRoundedIcon
        },
        {
          id: 'offer-list',
          title: 'Offers',
          type: 'item',
          url: '/offer/list',
          icon: LocalOfferRoundedIcon
        },
        {
          id: 'coupon-list',
          title: 'Coupons',
          type: 'item',
          url: '/coupon/list',
          icon: ConfirmationNumberRoundedIcon
        }
      ]
    },
    {
      id: 'accounts-management',
      title: 'Accounts',
      type: 'collapse',
      icon: PaymentsRoundedIcon,
      children: [
        {
          id: 'payment-method-list',
          title: 'Payment Methods',
          type: 'item',
          url: '/payment/method/list',
          icon: CreditCardRoundedIcon
        }
      ]
    },
    {
      id: 'master-management',
      title: 'Master',
      type: 'collapse',
      icon: WidgetsRoundedIcon,
      children: [
        {
          id: 'store-list',
          title: 'Stores',
          type: 'item',
          url: '/store/list',
          icon: StorefrontRoundedIcon
        },
        {
          id: 'banner-list',
          title: 'Banners',
          type: 'item',
          url: '/banner/list',
          icon: ViewCarouselRoundedIcon
        }
      ]
    },
    {
      id: 'authentication',
      title: 'Access Control',
      type: 'collapse',
      icon: AdminPanelSettingsRoundedIcon,
      children: [
        {
          id: 'user',
          title: 'Users',
          type: 'item',
          url: '/user/list',
          icon: ManageAccountsRoundedIcon,
          breadcrumbs: false
        },
        {
          id: 'role',
          title: 'Roles',
          type: 'item',
          url: '/role/list',
          icon: SecurityRoundedIcon,
          breadcrumbs: false
        },
        {
          id: 'day-open',
          title: 'Day Open',
          type: 'item',
          url: '/day/open/list',
          icon: TodayRoundedIcon,
          breadcrumbs: false
        }
      ],
    
    },
    {
  id: 'push-notifications',
  title: 'Push Notifications',
  type: 'item',
   url: '/notification/history',  
  icon: NotificationsRoundedIcon,
  
}
   
  ]
};

export default dashboard;
